<div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div class="field">
            <label for="nome" class="font-semibold block mb-2">Nome *</label>
            <input pInputText id="nome" formControlName="nome" maxlength="70" placeholder="Nome completo" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
        </div>

        <div class="field">
            <label for="nomeSocial" class="font-semibold block mb-2">Nome Social</label>
            <input pInputText id="nomeSocial" formControlName="nomeSocial" maxlength="70" placeholder="Nome social" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
        </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div class="field">
            <label for="nascimentoData" class="font-semibold block mb-2">Data de Nascimento *</label>
            <p-datepicker
                id="nascimentoData"
                formControlName="nascimentoData"
                dateFormat="dd/mm/yy"
                dataType="string"
                placeholder="DD/MM/AAAA"
                [showIcon]="true"
                [appendTo]="'body'"
                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                [readonlyInput]="!modoEdicao()"
            />
        </div>
        <div class="field">
            <label for="genero" class="font-semibold block mb-2">Gênero *</label>
            <p-select
                [appendTo]="'body'"
                id="genero"
                formControlName="genero"
                [options]="opcoesGenero()"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                [readonly]="!modoEdicao()"
            />
        </div>
        <div class="field">
            <label for="estadoCivil" class="font-semibold block mb-2">Estado Civil</label>
            <p-select
                [appendTo]="'body'"
                id="estadoCivil"
                formControlName="estadoCivil"
                [options]="opcoesEstadoCivil()"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione"
                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                [readonly]="!modoEdicao() || carregandoDominios()"
            />
        </div>
    </div>

    @if (mostrarSecaoDeficiencias()) {
        <div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                <div class="field">
                    <label for="comDeficiencia" class="font-semibold block mb-2">Com Deficiência</label>
                    <p-select
                        [appendTo]="'body'"
                        id="comDeficiencia"
                        formControlName="comDeficiencia"
                        [options]="opcoesSimNao()"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Selecione"
                        [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                        [readonly]="!modoEdicao()"
                    />
                </div>
                @if (comDeficiencia() === 'S') {
                    <div class="field">
                        <label class="font-semibold block mb-2">Detalhes</label>
                        <p-button type="button" label="Detalhar deficiência" icon="pi pi-external-link" styleClass="p-button-outlined w-full" (onClick)="abrirDialogDeficiencia.emit()"></p-button>
                    </div>
                }
            </div>
        </div>
    }
</div>
